function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { billCateApi } from '@/api/enterprise';
import oaFromBox from '@/components/common/oaFromBox';
export default {
  name: 'FormBox',
  components: {
    oaFromBox: oaFromBox
  },
  data: function data() {
    return {
      pickerOptions: this.$pickerOptionsTimeEle,
      timeVal: [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')],
      tableFrom: {
        time: '',
        status: [],
        type: '',
        cate_id: []
      },
      statusOptions: [{
        label: this.$t('toptable.all'),
        value: ''
      }],
      sexOptions: [{
        label: this.$t('finance.all'),
        value: ''
      }, {
        label: this.$t('finance.income'),
        value: '1'
      }, {
        label: this.$t('finance.pay'),
        value: '0'
      }],
      search: [{
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time',
        form_value: 'date_picker',
        data_dict: [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')]
      }, {
        field_name: '账目分类',
        field_name_en: 'status',
        form_value: 'cascader',
        data_dict: [],
        props: {
          collapseTags: true
        }
      }],
      treeData: [{
        options: [{
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '收入'
        }, {
          value: '0',
          label: '支出'
        }]
      }]
    };
  },
  mounted: function mounted() {
    this.tableFrom.time = this.timeVal[0] + '-' + this.timeVal[1];
    this.getBillCate();
    this.confirmData(this.tableFrom);
  },
  methods: {
    // 搜索记账类型
    handType: function handType(e) {
      this.tableFrom.type = e.value;
      this.tableFrom.status = [];
      this.tableFrom.cate_id = [];
      if (e.value === '') {
        this.statusOptions = [];
        this.tableFrom.status = [];
        this.tableFrom.cate_id = [];
        this.getBillCate(e.value);
      } else {
        this.statusOptions = this.getBillCate(e.value);
      }
      this.confirmData(this.tableFrom);
    },
    unique: function unique(arr) {
      return Array.from(new Set(arr));
    },
    // 获取收入类型
    getBillCate: function getBillCate(type) {
      var _this = this;
      var data = {
        types: type
      };
      var list = [{
        label: this.$t('toptable.all'),
        value: ''
      }];
      billCateApi(data).then(function (res) {
        res.data === undefined ? res.data = [] : res.data;
        _this.statusOptions = res.data;
        _this.setDataDict('status', res.data);
      });
      return list;
    },
    confirmData: function confirmData(where) {
      var _this2 = this;
      if (where == 'reset') {
        this.timeVal = [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')];
        this.search[0].data_dict = this.timeVal;
        where = {
          time: this.tableFrom.time = this.timeVal[0] + '-' + this.timeVal[1],
          status: [],
          type: '',
          cate_id: []
        };
      }
      this.tableFrom = _objectSpread(_objectSpread({}, this.tableFrom), where);
      Object.keys(this.tableFrom).forEach(function (key) {
        if (key == 'cate_id') {
          var arr2 = [].concat.apply([], _this2.tableFrom.status);
          if (arr2.length > 0) {
            _this2.tableFrom.cate_id = _this2.unique(arr2);
          } else {
            _this2.tableFrom.cate_id = [];
          }
        }
      });
      this.$emit('confirmData', this.tableFrom);
    },
    setDataDict: function setDataDict(field_name_en, data_dict) {
      for (var i = 0; i < this.search.length; i++) {
        if (this.search[i].field_name_en == field_name_en) {
          this.search[i].data_dict = data_dict;
          break;
        }
      }
    }
  }
};